import { useFormContext } from "react-hook-form";
import {} from "../styles/styledComponents";
import MountingTypeField from "../types/MountingTypeField";

type CheckBoxProps = {
  field: MountingTypeField;
};

const CheckBox = (props: CheckBoxProps) => {
  const { field } = props;

  const { register } = useFormContext();

  return (
    <div
      style={{
        display: "inline-flex",
        flexDirection: "row-reverse",
        alignItems: "center",
        gap: "15px",
      }}
    >
      <label style={{ marginTop: "1px" }} htmlFor={field.id.toString()}>
        {field.label}
      </label>
      <input
        style={{ width: "18px", height: "18px", margin: "0" }}
        id={field.id.toString()}
        type="checkbox"
        defaultChecked={Boolean(field.defaultValue)}
        {...register(field.id.toString())}
      />
      {/* <StyledInfoMessage id={field.name + "-info"}>
        {field.description}
      </StyledInfoMessage>
      <StyledError id={field.name + "-error"} role="alert" aria-atomic="true">
        {errors[field.id.toString()]?.message}
      </StyledError> */}
    </div>
  );
};

export default CheckBox;
